<template>
  <div class="managerUserOrderView">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="General" name="general">
          <custome-table tableType="object" :custSpan="6" :data="custName" :dataItem="basicInformation"></custome-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import loading from '@/utils/loading.json'
import apis from '@/services'
import customeTable from '@/components/customeTable'
import jsonData from './jsonData'
import { mixin } from '@/mixins/viewDiolog'

export default {
  components: {
    customeTable
  },
  mixins: [mixin],
  data () {
    return {
      custName: {},
      activeName: 'general',
      basicInformation: jsonData.basicInformation
    }
  },
  created () { this.init() },
  methods: {
    async init () {
      this.$store.state.app.loading = this.$loading(loading)
      const res = await apis.CrmUsers.getCrmUsersdtails(this.$route.params.id)
      if (res.status === 200) {
        this.custName = res.data.user
      }
      this.$store.state.app.loading.close()
    },
    async handleClick (type, data) { }
  }
}
</script>

<style lang="scss" scope>
.managerUserOrderView {
  .del-oder-item-dialog-body {
    .heder {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .avatar {
        flex-shrink: 0;
      }
    }
    .info-box {
      margin-left: 12px;
      margin-bottom: -12px;
      .title {
        margin-bottom: 12px;
      }
    }
    .notice {
      margin-bottom: 12px;
    }
  }
}
</style>
